import React from 'react';
import { Radio } from "@chakra-ui/react";
import {

  RadioGroupControl,

} from "formik-chakra-ui";

function RadioInput(props) {
  const { name,  title,  list } = props


  return (

      <div className="field_section_radio">

        <RadioGroupControl name={name} label={title}>
          {list?.map((item) => {
            return (
              <Radio value={item.id}>{item.name}</Radio>
            )

          })}

        </RadioGroupControl>

      </div>

  );
}

export default RadioInput;